/**
 * API 回傳資料的維護種類之列舉ㄋ
 *
 * @export
 * @enum {number}
 */
export enum VisibilityRuleType {
	ONLINE = 'ONLINE',
}
